import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import DateField from "./date";
import { Box, FormLabel } from "@mui/material";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const INPUT_ROW_MIN_HEIGHT = 40;

const labelSx = {
  color: themeColorsDesingSystem.text.primary,
  fontSize: ".875rem",
  fontWeight: "600",
  lineHeight: 1.5,
  mb: 0,
  fontFamily: "Open Sans,sans-serif",
  display: "block",
};

export default function FromToDateField({
  label,
  disabled,
  initialDate,
  finalDate,
  setInitialDate,
  setFinalDate,
  pattern = "br",
  disablePrefixLabels = false,
  validateMaxDate = false,
  validateMinDateToday = false,
  validateDateRange = false,
  embedded = false,
}) {
  const handleInitialDateChange = (value) => {
    setInitialDate(value);
    if (validateDateRange && finalDate) {
      const dateFormat = pattern === "br" ? "DD/MM/YYYY" : "MM/DD/YYYY";
      const newInitialMoment = moment(value, dateFormat);
      const finalMoment = moment(finalDate, dateFormat);
      if (
        newInitialMoment.isValid() &&
        finalMoment.isValid() &&
        newInitialMoment.isAfter(finalMoment, "day")
      ) {
        setFinalDate("");
      }
    }
  };

  const isFinalDateValid = (current) => {
    if (validateMaxDate) {
      const hoje = moment().startOf("day");
      if (current.isAfter(hoje, "day")) {
        return false;
      }
    }
    if (validateDateRange && initialDate) {
      const dateFormat = pattern === "br" ? "DD/MM/YYYY" : "MM/DD/YYYY";
      const initialMoment = moment(initialDate, dateFormat);
      if (!initialMoment.isValid()) return true;
      return (
        current.isAfter(initialMoment, "day") ||
        current.isSame(initialMoment, "day")
      );
    }
    return true;
  };

  const isInitialDateValid = (current) => {
    if (validateMaxDate) {
      const hoje = moment().startOf("day");
      if (current.isAfter(hoje, "day")) {
        return false;
      }
    }
    // Não deixa escolher uma data de início já passada (calendário só restringe o que pode ser
    // selecionado daqui pra frente — se o valor atual já veio no passado, ex. editando uma vitrine já
    // iniciada, ele continua exibido normalmente, só não dá pra trocar por outra data passada).
    if (validateMinDateToday) {
      const hoje = moment().startOf("day");
      if (current.isBefore(hoje, "day")) {
        return false;
      }
    }
    if (validateDateRange && finalDate) {
      const dateFormat = pattern === "br" ? "DD/MM/YYYY" : "MM/DD/YYYY";
      const finalMoment = moment(finalDate, dateFormat);
      if (!finalMoment.isValid()) return true;
      return (
        current.isBefore(finalMoment, "day") ||
        current.isSame(finalMoment, "day")
      );
    }
    return true;
  };

  const prefixLabel = (text) => (
    <Box
      display="flex"
      alignItems="center"
      minHeight={INPUT_ROW_MIN_HEIGHT}
    >
      <Typography variant="caption" style={{ whiteSpace: "nowrap" }}>
        {text}
      </Typography>
    </Box>
  );

  const content = (
    <Box width={embedded ? "100%" : undefined}>
      {label && (
        <FormLabel sx={labelSx}>{label}</FormLabel>
      )}
      <Grid
        container
        spacing={embedded ? 1 : 2}
        alignItems="center"
        wrap={embedded ? "nowrap" : "wrap"}
      >
        {!disablePrefixLabels && (
          <Grid item>{prefixLabel("De:")}</Grid>
        )}
        <Grid
          item
          xs={disablePrefixLabels ? 6 : true}
          sm
          style={{ minWidth: embedded ? 100 : undefined }}
        >
          <DateField
            value={initialDate}
            onChange={handleInitialDateChange}
            disabled={disabled}
            pattern={pattern}
            isValidDate={isInitialDateValid}
          />
        </Grid>
        {!disablePrefixLabels && (
          <Grid item>{prefixLabel("Até:")}</Grid>
        )}
        <Grid
          item
          xs={disablePrefixLabels ? 6 : true}
          sm
          style={{ minWidth: embedded ? 100 : undefined }}
        >
          <DateField
            value={finalDate}
            onChange={setFinalDate}
            isValidDate={isFinalDateValid}
            disabled={disabled || !initialDate}
            pattern={pattern}
          />
        </Grid>
      </Grid>
    </Box>
  );

  if (embedded) {
    return content;
  }

  return (
    <Grid item xs={12} md={6} lg={4}>
      {content}
    </Grid>
  );
}
